<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-8.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getPromoSignupList()"
          variant="info"
          size="sm"
        )

  .card-body
    .row
      .col-12 
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.sortable(width="7%")
                  span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
                th.sortable(width="9%")
                  span(:title="$t('ui.promo_name')") {{ $t('ui.promo_name') }}
                th.sortable(width="8%")
                  span(:title="$t('ui.bonus_amount')") {{ $t('ui.bonus_amount') }}
                th.sortable(width="6%")
                  span(:title="$t('ui.rollover')") {{ $t("ui.short.rollover") }}
                th.sortable(width="6%")
                  span(:title="$t('ui.criteria')") {{ $t("ui.short.criteria") }}
                th.text-center.sortable(width="9%")
                  span(:title="$t('ui.withhold_bonus')") {{ $t("ui.withhold_bonus") }}
                th.sortable(width="9%")
                  span(:title="$t('ui.withhold_amount')") {{ $t("ui.withhold_amt") }}
                th.sortable(width="10%")
                  span(:title="$t('ui.max_withdraw_amount')") {{ $t("ui.max_withdraw_amt") }}
                th.sortable(width="30%" )
                  span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                th.text-center.sortable(width="5%" )
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="5%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right.sortable(width="6%")
                  span(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                th.text-right.sortable(width="6%")
                  span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
            tbody.clusterize-content
              tr(v-if="promoList.length == 0")
                td(:colspan="13").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in promoList")
                tr(:class="$helpers.rowClassBitPromo(item.status)")
                  td
                    span(:title="item.promotion_id") {{ item.promotion_id }}
                  td
                    span(:title="item.promotion_name") {{ item.promotion_name }}
                  td
                    span(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                  td
                    span(:title="item.rollover") {{ item.rollover }}
                  td
                    span(:title="item.criteria") {{ item.criteria }}
                  td.text-center
                    span
                      i(:class="{'fas fa-check text-info': item.withhold_bonus, 'fas fa-times text-warning': !item.withhold_bonus  }")
                  td
                    span(:title="$n(item.withhold_amount, 'currency')") {{ $n(item.withhold_amount, 'currency') }}
                  td
                    span(:title="$n(item.max_withdraw_amount, 'currency')") {{ $n(item.max_withdraw_amount, 'currency') }}
                  td
                    template(v-if="item.provider_list")
                      a.float-right.pointer(v-if="item.provider_list.split(',').map(p => p.trim()).length > 5" @click="onOffDetail(item)")
                        i.fa(:class="currId == item.promotion_id ? 'fa-minus' : 'fa-plus'")
                      b-badge.mr-1.mb-1(
                        v-for="(provider, i) in (item.provider_list.split(',').map(p => p.trim()).slice(0, 5))"
                        :key="provider"
                        variant="secondary"
                      )
                        | {{ provider }}
                    template(v-else)
                      b-badge {{ $t('ui.all') }}
                  td
                    div.d-flex.justify-content-center.align-items-center
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="changedStatus(item, $event)" :disabled="!isEditAccess")
                        span.custom-switch-indicator
                  td.text-center(v-if="isEditAccess")
                    span
                      a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onUpdate(item)" :title="$t('ui.update')")
                  td.text-right
                    span(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                  td.text-right
                    span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") }}
                tr(v-if="isShowDetail == true && currId == item.promotion_id")
                  td(colspan="13")
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th
                            span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                      tbody.clusterize-content
                        tr
                          td
                            template(v-if="item.provider_list")
                              b-badge.mr-1.mb-1(
                                v-for="(provider, i) in item.provider_list.split(',').map(p => p.trim())"
                                :key="provider"
                                variant="secondary"
                              )
                                | {{ provider }}

    editpromosignup(ref="editpromosignup" :item="selectedPromo" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editpromosignup from "@/components/promo/editPromoSignup.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editpromosignup,
  },
  data: () => ({
    loading: false,
    promoList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    selectedPromo: null,
    currId: null,
    isShowDetail: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_promosignup");
    }
  },
  mounted: function() {
  },
  methods: {
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.promotion_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.promotion_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.promotion_id;
      }
    },
    refresh() {
      this.getPromoSignupList();
    },
    onUpdate(e) {
      this.selectedPromo = e;
      this.$refs.editpromosignup.$refs.editPromoSignup.show();
    },
    afterEdit: function(item) {
      this.getPromoSignupList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_promotion_signup"), this.$t("message.success"), "success");
    },
    getPromoSignupList: function() {
      let url = config.promotionSignupGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.promoList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_promo_signup_status_confirm", { name: item.promotion_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            this.getPromoSignupList();
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.promotionSignupStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        promotion_id: item.promotion_id,
        new_status: status,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPromoSignupList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getPromoSignupList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>